import { render, staticRenderFns } from "./IconSvgMusic.vue?vue&type=template&id=64b81c08&scoped=true&"
import script from "./IconSvgMusic.vue?vue&type=script&lang=js&"
export * from "./IconSvgMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b81c08",
  null
  
)

export default component.exports